<template>
	<main id="form">
		<form autocomplete="off" v-on:submit.self.stop.prevent="validateForm()">
			<h2>{{this.properties && getLabel(this.properties.title)}}</h2>
			<ul v-if="properties.fields">
				<li>
					<pools_radio_input v-on:validateField="validateExtraInput"  v-bind:params="getParams('associative_school')" v-bind:oldValue="oldValue['associative_school']" v-bind:lang="lang"></pools_radio_input>
				</li>

				<li v-if="display.associative_school == '4'">
					<text_input v-on:validateField="validateField" v-bind:params="getParams('other')" v-bind:oldValue="oldValue['other']" v-bind:lang="lang"></text_input>
				</li>
				<li v-if="display.associative_school != 0">
					<radio_input v-on:validateField="validateField" v-bind:params="getParams('ey_partner')" v-bind:oldValue="oldValue['ey_partner']" v-bind:lang="lang"></radio_input>
				</li>
				<li v-if="display.associative_school != 0">
					<select_checkbox_input v-on:validateField="validateExtraInput" v-bind:params="getParams('role_association')" v-bind:oldValue="oldValue['role_association']" v-bind:lang="lang"></select_checkbox_input>
				</li>
				<li v-if="displayRoleAssociation">
					<text_input v-on:validateField="validateField" v-bind:params="getParams('other_role_association')" v-bind:oldValue="oldValue['other_role_association']" v-bind:lang="lang"></text_input>
				</li>
				<li>
					<radio_input v-on:validateField="validateField" v-bind:params="getParams('high_level_athlete')" v-bind:oldValue="oldValue['high_level_athlete']" v-bind:lang="lang"></radio_input>
				</li>
				<!--<li>
					<radio_input v-on:validateField="validateField" v-bind:params="getParams('experience_international')" v-bind:oldValue="oldValue['experience_international']" v-bind:lang="lang"></radio_input>
				</li>-->
			</ul>
			<button v-bind:class="isActive ? 'selected' : ''" type="submit">{{getLabel(fields.next)}}</button>
		</form>
	</main>
</template>

<script>
//Input components
import text_input from '@/components/candidate_forms/text_input.vue';
import radio_input from '@/components/candidate_forms/radio_input.vue';
import select_checkbox_input from '@/components/candidate_forms/select_checkbox_input.vue';
import pools_radio_input from '@/components/candidate_forms/pools_radio_input.vue';

import lib from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

function remove_associative_school(val){
	if(val != 4) delete this.answer["other"];
	if(val == 0) {
		delete this.answer["role_association"]
		delete this.answer["ey_partner"];
		this.display.role_association = false;
	}
}

function remove_role_association(val){
	if(val != 3) delete this.answer["other_role_association"];
}

function checkForm(scope){
	if(!scope.properties || !scope || !Array.isArray(scope.properties.fields)) return false;
	if(scope.display.associative_school == 0) return ['high_level_athlete', /*'experience_international'*/].every(e => scope.answer[e]);
	if(scope.display.associative_school == 4 && !scope.answer['other']) return false;
	if(scope.displayRoleAssociation && !scope.answer['other_role_association']) return false;
	return ['associative_school', 'high_level_athlete', /*'experience_international'*/, 'ey_partner', 'role_association'].every(e => scope.answer[e]);
}
export default {
	name: 'association_commitmentTpl',
	data() {
		return {
			answer : {},
			oldValue : {},
			isActive : false,
			display : {
				associative_school: false,
				role_association : false
			},
			fields : {
				next : {
					fr : 'Valider',
					en : 'Next'
				}
			}
		}
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	components : {
		text_input, radio_input, pools_radio_input,select_checkbox_input
	},
	methods : {
		validateForm : function() {
			if(!checkForm(this)) return;
			let out = {};
			remove_associative_school.call(this, this.answer['associative_school']);
			remove_role_association.call(this, this.answer['role_association']);
			this.properties.fields.forEach( field => {
				if(this.answer[field.params.name]) out[field.params.name] = this.answer[field.params.name];
			});
			this.$emit('validateStep', this.$options.name, out);
		},
		validateField : function(name, value) {
			this.answer[name] = value;
			this.isActive = checkForm(this);
		},
		validateExtraInput : function(name, value) {
			const params = this.getParams(name);
			if(typeof(this.display[name]) != "undefined") this.display[name] = value;
			this.answer[name] = value;
			this.isActive = checkForm(this);
		},
		scrollToThisInput : function(event) {
			return lib.scrollToElem(event.target);
		},
		getParams : function(name){
			return this.properties.fields.find(x => x.params.name == name).params;
		},
		getLabel : componentTools.getLabel
	},
	computed : {
		displayRoleAssociation : function() {
			const ans = this.display.role_association;
			return ans && (ans == 3 || !!ans.find(e => e == 3));
		}
	},
	watch : {
		currentSession : {
			handler : function(val){
				let candidateTplRes = val.stepsResults && val.stepsResults[this.$options.name + '_' + this.templateIndex];
				if(!candidateTplRes){
					this.consent = false;
					Object.keys(this.answer).forEach(k => this.$set(this.oldValue, k, null)); //cf vue reactivity for binded object properties
					this.answer = {};
				}
			},
			deep : true,
		},
		"display.associative_school" : remove_associative_school,
		"display.role_association" : remove_role_association,
	},
	created : function(){
		componentTools.created.call(this);
		const oldRes = this.currentSession.stepsResults[this.$options.name + '_' + this.templateIndex];
		if(oldRes) this.oldValue = oldRes;
	},
	mounted : componentTools.mounted
};
</script>

<style lang="less">
@import '../../assets/less/conf.import.less';
#form ul{
	li{
		position: relative;
		margin-top: 3%;
		margin-bottom: 3%;
		label{
			position: absolute;
			left: 0;
			margin-top: 2%;
			max-width: 40%;
			text-align: left;
		}
		input{
			&[type="date"]{
				width: 40%;
				margin-left: 60%;
			}
			&[type="checkbox"], &[type="radio"]{
				display: inline-block;
			}
			&[type="text"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="email"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="number"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="tel"]{
				width: 50%;
				margin-left: 50%;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ey/association_commitment.vue